export const translations = {
  it: {
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.giftCard": "Gift Card",
    "nav.about": "Chi siamo",
    "nav.reviews": "Recensioni",
    "nav.contact": "Contatti",
    "nav.account": "Account",
    "nav.login": "Accedi",
    "nav.logout": "Esci",

    "hero.eyebrow": "Cosmetici Luxury · Made in Italy",
    "hero.title1": "La bellezza come",
    "hero.title2": "rituale",
    "hero.subtitle":
      "Skincare, profumi e fragranze d'ambiente creati con maestria artigianale italiana. Formule pure, gesti essenziali.",
    "hero.cta": "Scopri la collezione",
    "hero.cta2": "La nostra storia",

    "home.categories.title": "Le nostre collezioni",
    "home.categories.subtitle": "Tre universi olfattivi, un'unica filosofia di eleganza.",
    "home.featured.title": "Selezione del momento",
    "home.featured.subtitle": "I nostri pezzi più amati, scelti per te.",
    "home.story.eyebrow": "La nostra essenza",
    "home.story.title": "Nati in Italia,\ncreati per durare",
    "home.story.body":
      "Kaós nasce dall'incontro tra la tradizione cosmetica italiana e una visione contemporanea del lusso. Ogni formula è sviluppata nei nostri laboratori, con ingredienti selezionati e un rispetto assoluto per la pelle e per l'ambiente.",
    "home.story.cta": "Scopri di più",
    "home.promo": "Spedizione gratuita",
    "home.newsletter.title": "Entra nella lista privata",
    "home.newsletter.subtitle":
      "Anteprime, rituali di bellezza e offerte riservate. Inizia con la spedizione gratuita.",
    "home.newsletter.placeholder": "La tua email",
    "home.newsletter.cta": "Iscrivimi",
    "home.newsletter.success": "Iscrizione completata. Controlla la tua email.",
    "home.newsletter.already": "Sei già iscritto/a alla lista.",

    "shop.title": "Shop",
    "shop.subtitle": "Esplora l'intera collezione Kaós.",
    "shop.all": "Tutti",
    "shop.empty": "Nessun prodotto in questa categoria.",
    "shop.from": "da",
    "shop.olfactoryFamilies": "Famiglie olfattive",
    "shop.whatsappCatalog": "Visualizza il catalogo completo su WhatsApp",
    "shop.allProducts": "Tutti i prodotti",
    "shop.offers": "Offerte a tempo",
    "shop.limited": "Ultimi pezzi",

    "product.benefits": "Benefici",
    "product.pyramid": "Piramide olfattiva",
    "product.topNotes": "Testa",
    "product.heartNotes": "Cuore",
    "product.baseNotes": "Fondo",
    "product.format": "Formato",
    "product.addToCart": "Aggiungi al carrello",
    "product.added": "Aggiunto al carrello",
    "product.description": "Descrizione",
    "product.related": "Potrebbe piacerti anche",
    "product.back": "Torna allo shop",
    "product.available": "Disponibile",
    "product.availableCount": "Disponibilità: {count} pezzi",
    "product.onlyLeft": "Disponibilità limitata: solo {count} pezzi",
    "product.outOfStock": "Esaurito",

    "cart.title": "Il tuo carrello",
    "cart.empty": "Il tuo carrello è vuoto.",
    "cart.subtotal": "Subtotale",
    "cart.shipping": "Spedizione",
    "cart.free": "Gratuita",
    "cart.checkout": "Vai al checkout",
    "cart.remove": "Rimuovi",
    "cart.continue": "Continua lo shopping",

    "about.eyebrow": "Chi siamo",
    "about.title": "L'arte italiana\ndella cura",
    "about.intro":
      "“Once upon a time...” Così iniziano le favole. La mia, invece, è iniziata nella vita reale.",
    "about.story.title": "La storia di Kaós",
    "about.story.p1":
      "Kaós Luxury Cosmetics® nasce dalla passione per la cosmetica e dal desiderio di creare prodotti che uniscano qualità, efficacia e delicatezza.",
    "about.story.p2":
      "La nostra storia prende vita dalla ricerca di cosmetici adatti anche alle pelli più sensibili, trasformando un’esperienza personale in una missione: offrire una linea artigianale, rigorosamente Made in Italy, realizzata con ingredienti selezionati e formulazioni attente al benessere della pelle.",
    "about.story.p3":
      "Crediamo che prendersi cura di sé sia molto più di un gesto quotidiano: è un momento di benessere, equilibrio e amore per sé stessi. Per questo ogni prodotto Kaós nasce per accompagnare la skincare e non solo, con qualità, passione e autenticità.",
    "about.story.welcome": "Benvenuti nel mondo di Kaós. 💗",

    "reviews.title": "Recensioni",
    "reviews.subtitle": "La parola a chi ha scelto Kaós.",
    "reviews.write": "Scrivi una recensione",
    "reviews.form.name": "Nome",
    "reviews.form.rating": "Valutazione",
    "reviews.form.title": "Titolo",
    "reviews.form.body": "La tua recensione",
    "reviews.form.submit": "Pubblica",
    "reviews.form.success": "Grazie per la tua recensione!",

    "contact.title": "Contatti",
    "contact.subtitle": "Siamo a tua disposizione per qualsiasi richiesta.",
    "contact.name": "Nome",
    "contact.email": "Email",
    "contact.message": "Messaggio",
    "contact.submit": "Invia messaggio",
    "contact.success": "Messaggio inviato. Ti risponderemo al più presto.",
    "contact.info.title": "Informazioni",

    "auth.loginTitle": "Bentornato/a",
    "auth.registerTitle": "Crea il tuo account",
    "auth.name": "Nome",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.loginCta": "Accedi",
    "auth.registerCta": "Registrati",
    "auth.toRegister": "Non hai un account? Registrati",
    "auth.toLogin": "Hai già un account? Accedi",

    "account.title": "Il mio account",
    "account.welcome": "Ciao",
    "account.orders": "I miei ordini",
    "account.noOrders": "Non hai ancora effettuato ordini.",
    "account.logout": "Esci",

    "payment.success.title": "Ordine confermato",
    "payment.success.body": "Grazie per il tuo acquisto. Riceverai una conferma via email.",
    "payment.success.cta": "Torna alla home",
    "payment.processing": "Verifica del pagamento in corso...",
    "payment.cancel.title": "Pagamento annullato",
    "payment.cancel.body": "Nessun addebito è stato effettuato. Il tuo carrello ti aspetta.",
    "payment.cancel.cta": "Torna al carrello",

    "footer.tagline": "Cosmetici Luxury Made in Italy.",
    "footer.shop": "Shop",
    "footer.company": "Azienda",
    "footer.follow": "Seguici",
    "footer.rights": "Tutti i diritti riservati.",
    "nav.reseller": "Diventa rivenditore",
    "nav.skinTest": "Test della pelle",
    "product.family": "Famiglia olfattiva",
    "product.sale": "Offerta",
    "offer.endsIn": "L'offerta termina tra",
    "cd.d": "g", "cd.h": "h", "cd.m": "m", "cd.s": "s",
    "reseller.title": "Diventa rivenditore",
    "reseller.subtitle": "Porta Kaós nel tuo negozio. Compila il form e il nostro team commerciale ti contatterà.",
    "reseller.name": "Nome e cognome",
    "reseller.email": "Email",
    "reseller.phone": "Telefono",
    "reseller.company": "Azienda / Negozio",
    "reseller.message": "Raccontaci la tua attività e cosa ti interessa",
    "reseller.submit": "Invia richiesta",
    "reseller.success": "Richiesta inviata! Ti contatteremo al più presto.",
    "skin.title": "Che pelle hai?",
    "skin.subtitle": "Rispondi a 3 domande e scopri il rituale Kaós su misura per te.",
    "skin.start": "Inizia il test",
    "skin.restart": "Rifai il test",
    "skin.result": "Il tuo rituale consigliato",
    "skin.shop": "Scopri i prodotti",
    "skin.q1": "Come senti la tua pelle a metà giornata?",
    "skin.q1a": "Tira, secca", "skin.q1b": "Lucida, grassa", "skin.q1c": "Equilibrata",
    "skin.q2": "Qual è la tua priorità?",
    "skin.q2a": "Idratazione", "skin.q2b": "Luminosità", "skin.q2c": "Anti-età",
    "skin.q3": "Come preferisci le texture?",
    "skin.q3a": "Ricche e nutrienti", "skin.q3b": "Leggere e fresche", "skin.q3c": "Sieri concentrati",
    "whatsapp.tooltip": "Serve aiuto? Scrivici su WhatsApp",
    "home.families.title": "Trova il tuo profumo per famiglia olfattiva",
    "home.families.subtitle": "Ogni fragranza Kaós appartiene a un mondo. Scopri il tuo.",
    "home.film.title": "Il gesto, il rito",
    "home.film.subtitle": "Un momento di bellezza in movimento.",
    "home.inclusive.eyebrow": "Skincare senza confini",
    "home.inclusive.title": "La cura della pelle appartiene a tutti",
    "home.inclusive.body": "Formule essenziali e rituali quotidiani pensati per ogni pelle, oltre ogni etichetta.",
    "home.inclusive.cta": "Scopri la skincare",
    "home.inclusive.imageAlt": "Uomo durante il proprio rituale skincare",
  },
  en: {
    "nav.home": "Home",
    "nav.shop": "Shop",
    "nav.giftCard": "Gift Card",
    "nav.about": "About",
    "nav.reviews": "Reviews",
    "nav.contact": "Contact",
    "nav.account": "Account",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",

    "hero.eyebrow": "Luxury Cosmetics · Made in Italy",
    "hero.title1": "Beauty as a",
    "hero.title2": "ritual",
    "hero.subtitle":
      "Skincare, perfumes and home fragrances crafted with Italian artisanal mastery. Pure formulas, essential gestures.",
    "hero.cta": "Discover the collection",
    "hero.cta2": "Our story",

    "home.categories.title": "Our collections",
    "home.categories.subtitle": "Three olfactory universes, one philosophy of elegance.",
    "home.featured.title": "Current selection",
    "home.featured.subtitle": "Our most loved pieces, chosen for you.",
    "home.story.eyebrow": "Our essence",
    "home.story.title": "Born in Italy,\nmade to last",
    "home.story.body":
      "Kaós is born from the meeting of Italian cosmetic tradition and a contemporary vision of luxury. Every formula is developed in our laboratories, with selected ingredients and absolute respect for the skin and the environment.",
    "home.story.cta": "Learn more",
    "home.promo": "Free shipping",
    "home.newsletter.title": "Join the private list",
    "home.newsletter.subtitle":
      "Previews, beauty rituals and reserved offers. Start with free shipping.",
    "home.newsletter.placeholder": "Your email",
    "home.newsletter.cta": "Subscribe",
    "home.newsletter.success": "Subscription complete. Check your email.",
    "home.newsletter.already": "You're already on the list.",

    "shop.title": "Shop",
    "shop.subtitle": "Explore the entire Kaós collection.",
    "shop.all": "All",
    "shop.empty": "No products in this category.",
    "shop.from": "from",
    "shop.olfactoryFamilies": "Olfactory families",
    "shop.whatsappCatalog": "View the full catalog on WhatsApp",
    "shop.allProducts": "All products",
    "shop.offers": "Limited-time offers",
    "shop.limited": "Last items",

    "product.benefits": "Benefits",
    "product.pyramid": "Olfactory pyramid",
    "product.topNotes": "Top",
    "product.heartNotes": "Heart",
    "product.baseNotes": "Base",
    "product.format": "Format",
    "product.addToCart": "Add to cart",
    "product.added": "Added to cart",
    "product.description": "Description",
    "product.related": "You may also like",
    "product.back": "Back to shop",
    "product.available": "Available",
    "product.availableCount": "Availability: {count} items",
    "product.onlyLeft": "Limited availability: only {count} left",
    "product.outOfStock": "Out of stock",

    "cart.title": "Your cart",
    "cart.empty": "Your cart is empty.",
    "cart.subtotal": "Subtotal",
    "cart.shipping": "Shipping",
    "cart.free": "Free",
    "cart.checkout": "Go to checkout",
    "cart.remove": "Remove",
    "cart.continue": "Continue shopping",

    "about.eyebrow": "About us",
    "about.title": "The Italian art\nof care",
    "about.intro":
      "“Once upon a time...” That is how fairy tales begin. Mine, however, began in real life.",
    "about.story.title": "The story of Kaós",
    "about.story.p1":
      "Kaós Luxury Cosmetics® was born from a passion for cosmetics and the desire to create products that combine quality, efficacy and gentleness.",
    "about.story.p2":
      "Our story began with the search for cosmetics suitable even for the most sensitive skin, transforming a personal experience into a mission: to offer an artisanal line, proudly Made in Italy, created with carefully selected ingredients and formulas designed with skin wellbeing in mind.",
    "about.story.p3":
      "We believe that caring for yourself is much more than a daily gesture: it is a moment of wellbeing, balance and self-love. This is why every Kaós product is created to accompany your skincare ritual and beyond, with quality, passion and authenticity.",
    "about.story.welcome": "Welcome to the world of Kaós. 💗",

    "reviews.title": "Reviews",
    "reviews.subtitle": "In the words of those who chose Kaós.",
    "reviews.write": "Write a review",
    "reviews.form.name": "Name",
    "reviews.form.rating": "Rating",
    "reviews.form.title": "Title",
    "reviews.form.body": "Your review",
    "reviews.form.submit": "Publish",
    "reviews.form.success": "Thank you for your review!",

    "contact.title": "Contact",
    "contact.subtitle": "We're here for any request.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.submit": "Send message",
    "contact.success": "Message sent. We'll get back to you soon.",
    "contact.info.title": "Information",

    "auth.loginTitle": "Welcome back",
    "auth.registerTitle": "Create your account",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.loginCta": "Sign in",
    "auth.registerCta": "Sign up",
    "auth.toRegister": "Don't have an account? Sign up",
    "auth.toLogin": "Already have an account? Sign in",

    "account.title": "My account",
    "account.welcome": "Hi",
    "account.orders": "My orders",
    "account.noOrders": "You haven't placed any orders yet.",
    "account.logout": "Sign out",

    "payment.success.title": "Order confirmed",
    "payment.success.body": "Thank you for your purchase. You'll receive a confirmation by email.",
    "payment.success.cta": "Back to home",
    "payment.processing": "Verifying your payment...",
    "payment.cancel.title": "Payment cancelled",
    "payment.cancel.body": "No charge was made. Your cart is waiting for you.",
    "payment.cancel.cta": "Back to cart",

    "footer.tagline": "Luxury Cosmetics Made in Italy.",
    "footer.shop": "Shop",
    "footer.company": "Company",
    "footer.follow": "Follow us",
    "footer.rights": "All rights reserved.",
    "nav.reseller": "Become a reseller",
    "nav.skinTest": "Skin test",
    "product.family": "Olfactory family",
    "product.sale": "Sale",
    "offer.endsIn": "Offer ends in",
    "cd.d": "d", "cd.h": "h", "cd.m": "m", "cd.s": "s",
    "reseller.title": "Become a reseller",
    "reseller.subtitle": "Bring Kaós to your store. Fill in the form and our sales team will contact you.",
    "reseller.name": "Full name",
    "reseller.email": "Email",
    "reseller.phone": "Phone",
    "reseller.company": "Company / Store",
    "reseller.message": "Tell us about your business and what you're interested in",
    "reseller.submit": "Send request",
    "reseller.success": "Request sent! We'll contact you soon.",
    "skin.title": "What's your skin type?",
    "skin.subtitle": "Answer 3 questions and discover your tailored Kaós ritual.",
    "skin.start": "Start the test",
    "skin.restart": "Retake the test",
    "skin.result": "Your recommended ritual",
    "skin.shop": "Discover the products",
    "skin.q1": "How does your skin feel mid-day?",
    "skin.q1a": "Tight, dry", "skin.q1b": "Shiny, oily", "skin.q1c": "Balanced",
    "skin.q2": "What's your priority?",
    "skin.q2a": "Hydration", "skin.q2b": "Radiance", "skin.q2c": "Anti-aging",
    "skin.q3": "How do you like textures?",
    "skin.q3a": "Rich and nourishing", "skin.q3b": "Light and fresh", "skin.q3c": "Concentrated serums",
    "whatsapp.tooltip": "Need help? Message us on WhatsApp",
    "home.families.title": "Find your fragrance by olfactory family",
    "home.families.subtitle": "Every Kaós fragrance belongs to a world. Discover yours.",
    "home.film.title": "The gesture, the ritual",
    "home.film.subtitle": "A moment of beauty in motion.",
    "home.inclusive.eyebrow": "Skincare without boundaries",
    "home.inclusive.title": "Skincare belongs to everyone",
    "home.inclusive.body": "Essential formulas and daily rituals designed for every skin, beyond labels.",
    "home.inclusive.cta": "Discover skincare",
    "home.inclusive.imageAlt": "Man during his skincare ritual",
  },
};
